import { noop, throttle } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import * as Layout from '../Layout';
import { StickySearchBarWrapper } from './components/StickySearchBarWrapper';
import * as styled from './primitives';
import {
    SEARCH_BAR,
    THROTTLE_WAIT,
} from './constants.js';
import SearchBar from './components/SearchBar';

const UNIVERSAL_SEARCH_ADDITIONAL_FIELDS = {
    namedSearchFiltering: 1,
    separateSemanticIndex: 1,
    useMostPopular: 1,
    trimResults: 1,
};

const AWS_API_HOST = process.env.AWS_API_HOST || '';

class UniversalSearchHeaderView extends React.PureComponent {
    state = {
        distanceSearchBarFromWindowTop: null,
    };

    static propTypes = {
        address: PropTypes.string,
        sticky: PropTypes.bool,
        insurancePickerErrorStateOverride: PropTypes.bool,
        onCTALinkClick: PropTypes.func,
        onCustomLinkClick: PropTypes.func,
        onLogoClick: PropTypes.func,
        pageName: PropTypes.string,
        searchQueryGuid: PropTypes.string.isRequired,
        sessionId: PropTypes.string.isRequired,
        setInsuranceType: PropTypes.func,
        showCollapseToggle: PropTypes.bool,
        trackingId: PropTypes.string.isRequired,
        trackSubmitSearch: PropTypes.func,
    };

    static defaultProps = {
        address: '',
        sticky: false,
        insurancePickerErrorStateOverride: false,
        onCTALinkClick: noop,
        onCustomLinkClick: noop,
        onLogoClick: noop,
        pageName: '',
        setInsuranceType: noop,
        showCollapseToggle: true,
        trackSubmitSearch: noop,
    };

    getSearchQueryGuid = () => this.props.searchQueryGuid;

    componentDidMount() {
        this.calculateScrollableDistance();
        window.addEventListener('resize', this.calculateScrollableDistance);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.calculateScrollableDistance);
    }

    calculateScrollableDistance = throttle(() => {
        if (this.searchBarContainer) {
            this.setState({
                distanceSearchBarFromWindowTop: this.searchBarContainer.getBoundingClientRect().top +
                this.searchBarContainer.children[0].offsetHeight,
            });
        }
    }, THROTTLE_WAIT);

    render() {
        const {
            distanceSearchBarFromWindowTop,
        } = this.state;

        const {
            address,
            carrierId,
            sticky,
            insurancePickerErrorStateOverride,
            onCTALinkClick,
            onCustomLinkClick,
            onLogoClick,
            pageName,
            planId,
            sessionId,
            showCollapseToggle,
            trackingId,
            trackSubmitSearch,
            setInsuranceType,
        } = this.props;

        const layoutHeaderProps = {
            onCTALinkClick,
            onCustomLinkClick,
            onLogoClick,
        };

        const ppsUniversalSearchProps = {
            additionalQueryParameters: UNIVERSAL_SEARCH_ADDITIONAL_FIELDS,
            carrierId,
            'data-test': 'search-bar-pps',
            enableBrowseSpecialtyForMobile: true,
            enablePrefixSearch: true,
            enableSemanticSpecialty: true,
            page: 'search',
            planId,
            searchQueryGuidGetter: this.getSearchQueryGuid,
            sessionId,
            trackingId,
            useElasticGrouping: true,
        };

        const locationPickerProps = {
            'data-test': 'search-bar-location',
            defaultValue: address,
            gaCategory: pageName, // used for tracking
            section: SEARCH_BAR, // used for tracking
        };

        const insurancePickerProps = {
            carrierId,
            'data-test': 'search-bar-insurance',
            errorStateOverride: insurancePickerErrorStateOverride,
            gaCategory: pageName, // used for tracking
            planId,
            section: SEARCH_BAR, // used for tracking
            showScanInsuranceCardButton: true,
        };

        const searchBarProps = {
            awsApiUrl: AWS_API_HOST,
            ppsUniversalSearchProps,
            locationPickerProps,
            insurancePickerProps,
            showCollapseToggle,
            trackSubmitSearch,
            setInsuranceType,
            gaCategory: pageName,
        };

        return (
            <div
                ref={node => this.searchBarContainer = node}
                data-test="universal-search-header"
            >
                <Layout.Header {...layoutHeaderProps} />
                {
                    sticky ? (
                        <StickySearchBarWrapper verticalScrollLimit={distanceSearchBarFromWindowTop}>
                            <Layout.PaddedContainer>
                                <SearchBar {...searchBarProps} />
                            </Layout.PaddedContainer>
                        </StickySearchBarWrapper>
                    ) : (
                        <styled.SearchBarWrapper>
                            <Layout.PaddedContainer>
                                <SearchBar {...searchBarProps} />
                            </Layout.PaddedContainer>
                        </styled.SearchBarWrapper>
                    )
                }
            </div>
        );
    }
}

export { UniversalSearchHeaderView as UniversalSearchHeader };
